import { getModuleOptions, selectAll, on, select, trigger } from 'modules/dom'

const MODULE_NAME = 'ctas'
const BUTTON_SELECTOR = '.js-button'
const SIGN_IN_TRIGGER_SELECTOR = '.js-modal-account'
const inputHidden = document.querySelector('.modal-login .login-submit input[type=hidden]')

const DEFAULT = {
  isLoggedIn: false
}

export default el => {
  const options = getModuleOptions(MODULE_NAME, el, DEFAULT)
  const buttonEls = selectAll(BUTTON_SELECTOR, el)
  if (!options.isLoggedIn && buttonEls.length) {
    buttonEls.map(button => {
      on('click', (e) => {
        e.preventDefault()
        const buttonHref = button.getAttribute('href')
        if (buttonHref.includes('oac_checking') === true && inputHidden) {
          inputHidden.setAttribute('value', inputHidden.value + '?oac_checking')
        }
        const signInButton = select(SIGN_IN_TRIGGER_SELECTOR)
        if (signInButton) {
          trigger('click', signInButton)
        }
      }, button)
    })
  }
}
